import React from 'react';
import SecurityAnalyzer from './components/SecurityLogAnalyzer';
import './App.css';

function App() {
  return (
    <div className="App">
      <SecurityAnalyzer />
    </div>
  );
}

export default App;
